import { hookstate } from "@hookstate/core";
import { PendingAuthPaymentConfigTypes } from "../components/payments/api/paymentApi";

// Persists the attempted purchase config across the auth wall so checkout can resume
// after login/signup inside the same browser session.
export const pendingAuthPaymentConfigStore = hookstate<
  PendingAuthPaymentConfigTypes | undefined
>(undefined);
